import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { store } from "./store/store";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import Modal from "react-modal";

Modal.setAppElement("#root");

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .catch(() => {});
  });
}

const toastConfig = {
  position: "top-right",
  style: {
    background: "white",
    color: "black",
  },

  duration: 4000,
  maxToasts: 3,

  toastOptions: {
    style: {},
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));

const AppWrapper = () => (
  <Provider store={store}>
    <App />
    <Toaster {...toastConfig} />
  </Provider>
);

root.render(<AppWrapper />);
